module.exports = __webpack_public_path__ + "img/VG@3x.892becd4.png";